"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconProgressOngoing = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconProgressOngoing = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12S0 18.628 0 12C0 5.373 5.373 0 12 0zm-.258 5.831a2.09 2.09 0 00-2.893 0 1.944 1.944 0 000 2.808L12.31 12l-3.462 3.36a1.946 1.946 0 000 2.809c.4.387.923.581 1.446.581.524 0 1.048-.194 1.447-.581l4.91-4.765a1.946 1.946 0 000-2.808z"
}));
exports.IconProgressOngoing = IconProgressOngoing;
//# sourceMappingURL=IconProgressOngoing.js.map